export default "__VITE_ASSET__D6tFtVk0__"